function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* Fork from ol-comtextmenu 4.1.0
 * https://github.com/jonataswalker/ol-contextmenu/tree/4.1.0
 * (c) Jonatas Walker
 * @license MIT
 **/

import { CSS_VARS, DEFAULT_OPTIONS, DEFAULT_ITEMS } from './constants';
import Control from 'ol/control/Control';
import { Internal } from './internal';
import { Html } from './html';
import { assert, mergeOptions, isDefAndNotNull } from './helpers/mix';
//import './sass/main.scss';

export var createContainer = function createContainer(hidden, width) {
  var container = document.createElement('div');
  var ul = document.createElement('ul');
  var klasses = [CSS_VARS.container, CSS_VARS.unselectable];
  hidden && klasses.push(CSS_VARS.hidden);
  container.className = klasses.join(' ');
  container.style.width = "".concat(parseInt( /*this.Base.options.*/width, 10), "px");
  container.appendChild(ul);
  return container;
};

/**
 * @class Base
 * @extends {ol.control.Control}
 */
var Base = /*#__PURE__*/function (_Control) {
  _inherits(Base, _Control);
  var _super = _createSuper(Base);
  /**
   * @constructor
   * @param {object|undefined} opt_options Options.
   */
  function Base() {
    var _this;
    var opt_options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Base);
    assert(_typeof(opt_options) == 'object', '@param `opt_options` should be object type!');
    var options = mergeOptions(DEFAULT_OPTIONS, opt_options);
    var container = createContainer(true, options.width);
    _this = _super.call(this, {
      element: container
    });
    _this.options = options;
    _this.container = container;
    _this.disabled = false;
    _this.Internal = new Internal(_assertThisInitialized(_this));
    _this.Html = new Html(_assertThisInitialized(_this));
    return _this;
  }

  /**
   * Remove all elements from the menu.
   */
  _createClass(Base, [{
    key: "clear",
    value: function clear() {
      Object.keys(this.Internal.items).forEach(this.Html.removeMenuEntry, this.Html);
    }

    /**
     * Close the menu programmatically.
     */
  }, {
    key: "close",
    value: function close() {
      this.Internal.closeMenu();
    }

    /**
     * Enable menu
     */
  }, {
    key: "enable",
    value: function enable() {
      this.disabled = false;
    }

    /**
     * Disable menu
     */
  }, {
    key: "disable",
    value: function disable() {
      this.disabled = true;
    }

    /**
     * @return {Array} Returns default items
     */
  }, {
    key: "getDefaultItems",
    value: function getDefaultItems() {
      return DEFAULT_ITEMS;
    }

    /**
     * @return {Number} Returns how many items
     */
  }, {
    key: "countItems",
    value: function countItems() {
      return Object.keys(this.Internal.items).length;
    }

    /**
     * Add items to the menu. This pushes each item in the provided array
     * to the end of the menu.
     * @param {Array} arr Array.
     */
  }, {
    key: "extend",
    value: function extend(arr) {
      assert(Array.isArray(arr), '@param `arr` should be an Array.');
      arr.forEach(this.push, this);
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return this.Internal.opened;
    }

    /**
     * Update the menu's position.
     */
  }, {
    key: "updatePosition",
    value: function updatePosition(pixel) {
      assert(Array.isArray(pixel), '@param `pixel` should be an Array.');
      if (this.isOpen()) {
        this.Internal.positionContainer(pixel);
      }
    }

    /**
     * Remove the last item of the menu.
     */
  }, {
    key: "pop",
    value: function pop() {
      var keys = Object.keys(this.Internal.items);
      this.Html.removeMenuEntry(keys[keys.length - 1]);
    }

    /**
     * Insert the provided item at the end of the menu.
     * @param {Object|String} item Item.
     */
  }, {
    key: "push",
    value: function push(item) {
      assert(isDefAndNotNull(item), '@param `item` must be informed.');
      this.Html.addMenuEntry(item);
    }

    /**
     * Remove the first item of the menu.
     */
  }, {
    key: "shift",
    value: function shift() {
      this.Html.removeMenuEntry(Object.keys(this.Internal.items)[0]);
    }

    /**
     * Not supposed to be used on app.
     */
  }, {
    key: "setMap",
    value: function setMap(map) {
      Control.prototype.setMap.call(this, map);
      if (map) {
        // let's start since now we have the map
        this.Internal.init(map, this);
      } else {
        // I'm removed from the map - remove listeners
        this.Internal.removeListeners();
      }
    }
  }]);
  return Base;
}(Control);
export { Base as default };